<template>
  <div class="row">
    <div class="col-2 b-form__container_min-width_200">
      <div>
        <label>{{$t('CONTENT.assets.lease_start_date')}}:</label>
        <datepicker class="b-datepicker" v-model="newStartDate" :formatter="datepickerFormat"></datepicker>
      </div>
    </div>
  </div>
</template>

<script>
import ChangePaymentStartDate from "../../models/commands/ChangePaymentStartDate";
import dateConverter from "@/utils/converters/date.converter";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  components: {},
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      newStartDateAsString: null
    };
  },
  computed: {
    newStartDate: {
      get() {
        if (this.newStartDateAsString === null) {
          return null;
        } else {
          return dateConverter.convertToDate(this.newStartDateAsString);
        }
      },
      set(newVal) {
        if (newVal !== null) {
          this.newStartDateAsString = dateConverter.convertToString(newVal);
        } else {
          this.newStartDateAsString = null;
        }
      }
    }
  },
  created() {
    this.newStartDateAsString = this.paymentParams.startDate;
  },
  methods: {
    cancel() {
      this.newStartDateAsString = this.paymentParams.startDate;
    },

    save() {
      const command = new ChangePaymentStartDate(
        this.paymentParams.idInDB,
        this.newStartDateAsString
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
